const origin = window.location.origin;              // e.g. http://localhost:3000 or https://siri.industry40.academy
const isLocalhost = window.location.hostname === "localhost";

export const COGNITO_DOMAIN = "https://auth.industry40.academy";
export const COGNITO_CLIENT_ID = "3mdtjcsicek87ekhp61ujffjtf";

export const COGNITO_REDIRECT_URI = origin;        // must be in Allowed callback URLs
export const COGNITO_LOGOUT_URI   = origin; // must be in Allowed sign-out URLs

export const COGNITO_SCOPES = "openid profile email";
